import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Box, Tooltip } from '@mui/material';
import { ahPath } from '../../../utilities/UrlPaths';

const OpenDisputesButton = ({ memberID, lotRefs, selectedLotsForDisputes, setCheckboxArray }) => {
  const { groupedData } = useSelector(state => state.reports?.sessionResults) || { groupedData: [] };
  const [lotsHaveOpenDispute, setLotsHaveOpenDispute] = useState(false);
  const [buttonMouseOver, setButtonMouseOver] = useState(false);

  // If memberID and lotRefs are provided, filter selectedLotsForDisputes to only those lots for this member
  const filteredSelectedLots = memberID && lotRefs
    ? selectedLotsForDisputes.filter(lotRef => lotRefs.includes(lotRef))
    : selectedLotsForDisputes;

  const selectedLotsCount = filteredSelectedLots.length;

  useEffect(() => {
    setLotsHaveOpenDispute(false);
    if (selectedLotsCount && groupedData?.length) {
      const openDisputeStats = ['b', 's', 'd', 'x', 'c'];
      filteredSelectedLots.forEach((ref) => {
        groupedData.forEach((bidder) => {
          const lotData = bidder.items.find(lot => lot.lotRef === ref);
          if (lotData) {
            if (openDisputeStats.indexOf(lotData.disputeStat) > -1) {
              setLotsHaveOpenDispute(true);
            }
          }
        });
      });
    }
  }, [filteredSelectedLots, groupedData, selectedLotsCount]);

  const isDisabled = !filteredSelectedLots.length || lotsHaveOpenDispute;

  return (
    <Box justifyContent="flex-end">
      <div
        onMouseEnter={() => setButtonMouseOver(true)}
        onMouseLeave={() => setButtonMouseOver(false)}
      >
        <Tooltip
          title={isDisabled ? 'Disputes cannot be opened on lots won by floor bidders' : ''}
          placement="top"
          arrow
        >
          <span>
            <Button
              variant="contained"
              color="primary"
              className="cursor-not-allowed placeBidbutton"
              disabled={isDisabled}
              onClick={() => {
                window.location.href = `${ahPath()}/ah/reports/openDisputes/${filteredSelectedLots}`;
                setCheckboxArray([]);
              }}
            >
              Open Disputes on Selected {selectedLotsCount > 0 && `(${selectedLotsCount})`}
            </Button>
          </span>
        </Tooltip>
      </div>
      {lotsHaveOpenDispute && buttonMouseOver && (
        <div className="cell-font-size error-text">
          Dispute already exists on selected lot{selectedLotsCount > 1 && 's'}
        </div>
      )}
    </Box>
  );
};

export default OpenDisputesButton;
